// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1X6N8","col":"CardReaderDesc_col__17Vc0","label":"CardReaderDesc_label__sVONI"};